export default __webpack_public_path__ + "static/media/services_dev_ios.f8bddd84.svg";